import React from "react";
import styles from "./index.module.less";

const Error = (props) => {
  return (
    <div className={styles["error-wrapper"]}>
      <img src={require("../../images/error/404.png")} alt="404" />
      <p>啊哦，出错了~</p>
      <button
        className={styles["error-btn"]}
        onClick={() => {
          props.history.push("/");
        }}
      >
        回到首页
      </button>
    </div>
  );
};

export default Error;
